// extracted by mini-css-extract-plugin
export default {"header":"CreateDeposit_header__+DigJ","styleError":"CreateDeposit_styleError__H4lFD","saveDeposit":"CreateDeposit_saveDeposit__iYfFa"};